<template>
  <div :class="themeStyleVs == 2 ? 'homde_page black_version' : 'homde_page'">
    <div class="home-nav" ref="homeNavRef">
      <van-nav-bar
        title="发现策略"
        left-text=""
        right-text=""
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
      >
        <template #right>
          <van-icon name="replay" size="18" :style="{ transform: rotateDegree }" />
        </template>
      </van-nav-bar>
    </div>

    <div class="not_login" v-if="!loginShow">
      <img src="../../assets/image/login_img.png" alt="" />
      <p>登录后即可查看当前频道内容，先去登录吧</p>
      <div class="btn_box" @click="goLink">立即登录</div>
    </div>

    <div class="home-body" v-else ref="homeBody">
      <div class="home-sel" @click="gotoSelectzh">
        <img src="@/assets/image/sel2x.png" alt="" v-if="themeStyleVs !== 2" />
        <img src="@/assets/image/sel2_2x.png" alt="" v-else />
        搜股票找近一个月关联组合
      </div>

      <div class="t_h_t_p_s">
        <p class="title">今日热门模拟交易盈亏</p>

        <ul class="graph_num">
          <li class="red">{{ toFixedNum(profitRatio, 2, '%') }}</li>
          <li class="green">{{ toFixedNum(lossRatio, 2, '%') }}</li>
        </ul>
        <ul class="graph">
          <li class="profit" :style="`width:${toFixedNum(profitRatio, 2, '%')}`"></li>
          <li
            class="flat"
            :style="`width:${toFixedNum(balanceRatio >= 98 ? 90 : balanceRatio, 2, '%')}`"
          ></li>
          <li class="loss" :style="`width:${toFixedNum(lossRatio, 2, '%')}`"></li>
        </ul>

        <ul class="graph_msg">
          <li>今日盈利占比</li>
          <li>今日亏损占比</li>
        </ul>
      </div>

      <div class="body-tabs" :key="rotation">
        <van-tabs
          v-model="bodyTabsActive"
          sticky
          scrollspy
          :ellipsis="false"
          :offset-top="offsetTop"
        >
          <van-tab title="模拟交易榜单" name="0">
            <Mnjybd></Mnjybd>
          </van-tab>
          <van-tab title="热门模拟交易" name="1">
            <Rmmnjy></Rmmnjy>
          </van-tab>
          <!-- <van-tab title="策略广场" name="2">
            <Clgc></Clgc>
          </van-tab> -->
          <van-tab title="模拟交易领涨股" name="3">
            <Jylzg></Jylzg>
          </van-tab>

          <van-tab title="模拟调仓动态" name="4">
            <Tcdt></Tcdt>
          </van-tab>

          <van-tab title="热门策略" name="5">
            <Rmcl></Rmcl>
          </van-tab>

          <van-tab title="策略热门股" name="6">
            <Clrmg></Clrmg>
          </van-tab>

          <van-tab title="更多优质策略" name="7">
            <Yzcl></Yzcl>
          </van-tab>
        </van-tabs>
      </div>

      <div class="statement">
        免责声明：本页面信息仅展示通过因子池和特定量化参数生成的相关历史客观数据统计结果，不代表未来趋势，仅供参考，不构成投资建议，投资有风险，入市需谨慎，如有他人借此进行非法荐股行为请及时向有关部门举报。
      </div>
    </div>

    <img class="user_btn" :src="userImg" alt="" @click.stop="goUser" v-if="!compareVersions(version , 9.73)" />
  </div>
</template>

<script>
import { getHotMokpanelSurvey } from '@/api/index.js';
import { mapMutations } from 'vuex';
import takeOut from '@/components/notHd/TakeOut.vue';
import vipInfo from '@/components/diaLog/vipInfo.vue';
import Mnjybd from '@/components/home/Mnjybd.vue';
import { toFixedNum,compareVersions } from '@/utils/format';
// 引入lodash的debounce函数
import debounce from 'lodash/debounce';
// import inobounce from 'inobounce'; //处理ios橡皮筋

import mixins from '@/mixins/index.js';
export default {
  name: 'Home',
  mixins: [mixins],
  components: {
    takeOut,
    vipInfo,
    Mnjybd
  },
  data() {
    return {
      rotateDegree: 'rotate(0deg)', // 初始化角度为0度
      rotation: 0,
      bodyTabsActive: 0,
      userImg: require('../../assets/image/userImg.png'),
      themeStyleVs: 1,
      loginShow: false,
      isVip: false,
      profitRatio: 0,
      lossRatio: 0,
      balanceRatio: 0,
      profitCount: 0,
      lossCount: 0,
      interval: null,
      version: 0,
      tokenExpirationTime: 0,
      offsetTop: 80
    };
  },
  filters: {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  created() {
    if (window.DzhAppJs) {
      DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('', 'true', 'interceptOnKeyDown'); //安卓里面禁用返回功能
    }

    let token = this.getUrlQuery('token') || '';
    // let u = navigator.userAgent;
    // if (u.indexOf('iPhone') > -1) {
    //   inobounce.enable();
    // }
    if (token) {
      // 通过点（.）分割字符串
      var tokenParts = token.split('.');
      // 如果有两个或更多部分，取第二部分作为时间戳
      var timestamp = tokenParts.length >= 2 ? tokenParts[1] : null;
      this.tokenExpirationTime = timestamp;

      // 调用函数检查时间戳是否有效
      var isValid = this.isTimestampValid(this.tokenExpirationTime);

      this.loginShow = isValid; //如果token有效正常显示返回true  失效之后返回false显示去登录按钮
    } else {
      this.loginShow = false;
    }

    this.resetState(); //重置部分vuex;
    this.resetBtnDisabled();
    this.resetContentNavBar();
  },
  mounted() {
    this.themeStyleVs = this.$route.query.themeStyleVs;

    if (this.loginShow) {
      this.version = this.$route.query.version;

      this.getHotMokpanelSurveyFun();

      this.interval = setInterval(() => {
        this.getHotMokpanelSurveyFun();
      }, 1000 * 60);

      // 使用 $refs 获取元素引用，并访问 offsetHeight 属性
      this.offsetTop = this.$refs.homeNavRef.offsetHeight - 5;
    }
  },
  methods: {
    toFixedNum,
    compareVersions,
    ...mapMutations(['resetState', 'resetBtnDisabled', 'resetContentNavBar']),

    isTimestampValid: function (timestamp) {
      // 获取当前时间戳
      var currentTimestamp = Math.floor(Date.now() / 1000); // 转换为秒级时间戳

      // 比较当前时间戳和给定的timestamp
      if (currentTimestamp > timestamp) {
        return false;
      } else {
        return true;
      }
    },

    onClickLeft: function () {
      location.href = 'dzh_browser_url&goto=0&screen=263';
    },
    // 使用debounce包装onClickRight函数，延迟执行500毫秒
    onClickRight: debounce(
      async function () {
        if (this.loginShow) {
          // 每次执行onClickRight时，增加360度
          this.rotateDegree = `rotate(${this.rotation + 360}deg)`;
          this.rotation += 360;

          // 然后执行你的其他逻辑
          await this.getHotMokpanelSurveyFun();

          const homeBodyElement = this.$refs.homeBody;
          if (homeBodyElement) {
            homeBodyElement.scrollTo({
              top: 0,
              behavior: 'smooth' // 平滑滚动
            });
          }
        } else {
          window.location.href = 'dzh_browser_url&goto=0&screen=442';
        }
      },
      500,
      { leading: true }
    ),

    getHotMokpanelSurveyFun: function () {
      var params = {};
      return getHotMokpanelSurvey(params)
        .then((res) => {
          this.profitRatio = res.data.profitRatio * 100; //盈利比率
          this.lossRatio = res.data.lossRatio * 100; //亏损比率
          this.balanceRatio = res.data.balanceRatio * 100; //平数量比率

          this.profitCount = res.data.profitCount; //盈利
          this.lossCount = res.data.lossCount; //亏损
        })
        .catch((err) => {
          this.$toast(err);
        });
    },

    goLink: function () {
      // DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
      //   'getDZHTokenFunc',
      //   JSON.stringify([]),
      //   'window.dzhwebjs.getDZHTokenFunc'
      // );
      window.location.href = 'dzh_browser_url&goto=0&screen=442';
    },
    goUser: function () {
      this.$router.push({
        path: '/my',
        name: 'My',
        query: this.$route.query
      });
      // this.$router.push({
      //   path: '/my',
      //   name: 'My',
      //   query: {
      //     DZHSPECIAL: '4325641'
      //   }
      // });

      // if (typeof DzhAppJs == 'undefined') {
      //   window.open('/my?token=' + (this.$route.query.token || ''));
      // } else {
      //   location.href = '/my?DZHSPECIAL=4325641';
      // }
    },

    //跳转搜索组合页面
    gotoSelectzh: function () {
      this.$router.push({
        path: '/selectZh',
        query: this.$route.query
      });
    }
  },
  beforeDestroy() {
    // 在组件销毁时移除事件监听，防止内存泄漏
    clearInterval(this.interval);
  }
};
</script>
<style lang="less" scoped>
@keyframes rotate360 {
  to {
    transform: rotate(360deg);
  }
}
.homde_page {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  .home-body {
    overflow-y: auto;
    height: calc(100vh - 86px);
    -webkit-overflow-scrolling: touch;
  }
  .home-nav {
    ::v-deep {
      .van-hairline--bottom::after {
        display: none;
      }
      .van-nav-bar {
        padding-top: 40px;
      }
      .van-nav-bar__left,
      .van-nav-bar__right {
        padding: 0 16px;
        .van-icon,
        .van-nav-bar__text {
          color: #333;
        }
      }
      .van-nav-bar__title {
        color: #333;
      }
      .van-icon-replay {
        transition: transform 0.3s ease; /* 添加过渡效果 */
      }
    }
  }
  .home-sel {
    border-radius: 38px;
    background: #f7f8fa;
    padding: 8px 16px;
    color: #999;
    text-align: center;
    font-size: 14px;
    margin: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 17px;
      height: 16px;
      margin-right: 4px;
    }
  }
  .t_h_t_p_s {
    border-radius: 8px;
    border: 1px solid #e5e5e5;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    padding: 16px;
    margin: 12px 16px 16px;
    background: url('../../assets/image/t_h_t_p_s2x.png') no-repeat right top;
    background-size: 100% 60%;
    .title {
      color: #222;
      font-size: 16px;
      font-weight: 600;
    }

    .graph_num {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 16px;
      li {
        font-size: 20px;
        font-weight: 500;
      }
    }

    .graph {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 4px;
      li {
        height: 8px;
        border-radius: 20px;
        flex-shrink: 0;
        min-width: 8px !important;
      }
      .profit {
        background: #ef3939;
      }
      .flat {
        background: #999;
        margin: 0 4px;
      }
      .loss {
        background: #1eac4e;
      }
    }

    .graph_msg {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 16px;
      margin-top: 4px;
      li {
        font-size: 11px;
        font-weight: 400;
        color: #999;
      }
    }
  }
  .body-tabs {
    ::v-deep {
      .van-tab {
        color: #555;
        font-size: 14px;
      }
      .van-tab--active {
        color: #222;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
      }
      .van-tabs__line {
        width: 20px;
        height: 3px;
        border-radius: 5px;
        background: #222;
      }
      // .van-sticky--fixed {
      //   // z-index: 0;
      // }
    }
  }
  .statement {
    color: #ccc;
    font-size: 12px;
    font-weight: 400;
    background: #f7f8fa;
    padding: 16px;
    margin-top: 16px;
  }
  .not_login {
    width: 100%;
    height: 100%;
    text-align: center;
    margin: 0 auto;
    padding-top: 68px;
    box-sizing: border-box;
    img {
      width: 201px;
      height: 131px;
      margin: 0 auto;
      margin-bottom: 14px;
    }
    p {
      color: rgba(0, 0, 0, 0.3);
      font-size: 14px;
      margin-bottom: 20px;
    }
    .btn_box {
      width: 100px;
      height: 34px;
      font-size: 14px;
      color: #fff;
      border-radius: 6px;
      background: #2568eb;
      text-align: center;
      line-height: 34px;
      margin: 0 auto;
    }
  }
  .user_btn {
    display: inline-block;
    width: 48px;
    height: 48px;
    position: fixed;
    bottom: 21px;
    right: 16px;
  }
}
</style>

<!-- 黑色 -->
<style lang="less" scoped>
.black_version {
  background: #1a1c26;
  .home-nav {
    ::v-deep {
      .van-nav-bar {
        background: #1a1c26;
        .van-icon,
        .van-nav-bar__title {
          color: #fff;
        }
      }
    }
  }
  .not_login {
    p {
      color: #fff;
    }
  }
  .home-sel {
    background: #1d202d;
    color: #6b7687;
  }
  .t_h_t_p_s {
    background: #272935 url('../../assets/image/t_h_t_p_s2x.png') no-repeat right top;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background-size: 100% 60%;
    .title {
      color: #e4e9fe;
    }

    .graph_num {
      li {
        color: #6b7687;
      }
    }

    .graph_msg {
      li {
        color: #6b7687;
      }
    }
  }

  .body-tabs {
    ::v-deep {
      .van-tabs__nav {
        background: #1a1c26;
        .van-tab {
          color: #aab9d1;
        }
        .van-tab--active {
          color: #e4e9fe;
        }
        .van-tabs__line {
          background: #e4e9fe;
        }
      }
    }
  }
  .statement {
    background: none;
    color: #6b7687;
  }
}
</style>
